import React from 'react';
import { Helmet } from 'react-helmet-async';

type SchemaType = 'WebSite' | 'Organization' | 'SoftwareApplication' | 'VideoObject' | 'WebPage';

interface SchemaJSONLDProps {
    type: SchemaType;
    data: Record<string, unknown>;
}

export const SchemaJSONLD: React.FC<SchemaJSONLDProps> = ({ type, data }) => {
    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': type,
        ...data
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(jsonLd)}
            </script>
        </Helmet>
    );
};
